var DateEnv = require('core/env/date');

module.exports = {
  provides: 'currentTimestamp',
  shouldTrack: true,

  // Get the timestamp right as the layer activates
  isLazy: true,

  getter: [
    /**
     * @returns {number}
     */
    function() {
      return DateEnv.now();
    },
  ],
};
